import React from "react";
import { Link } from "react-router-dom";

export default function BookNow({ packageId, children = "Book Now", className = "" }) {
  return <Link className={`button button-primary book-now-btn ${className}`} to={packageId ? `/book?package=${packageId}` : "/book"}>{children}</Link>;
}
